import { useEffect, useState, type ReactNode } from "react";
import { restoreDeviceSession, signOutSession } from "../../lib/device-session";

let startup: Promise<void> | undefined;

export function SessionStartup({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<"loading" | "ready" | "error">("loading");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    startup ??= restoreDeviceSession();
    void startup.then(() => { if (active) setStatus("ready"); }, () => { if (active) setStatus("error"); });
    return () => { active = false; };
  }, [attempt]);
  if (status === "ready") return children;
  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-cloud-50 p-6 text-cloud-800">
      <div className="max-w-sm text-center" role="status" aria-live="polite">
        <h1 className="text-2xl font-semibold">{status === "loading" ? "Opening Link…" : "Couldn't reconnect to Link"}</h1>
        <p className="mt-3 text-sm text-cloud-600">{status === "loading" ? "Checking your saved sign-in." : "Check your connection and try again. You don't need to enter your recovery phrase for a connection problem."}</p>
        {status === "error" && <div className="mt-6 flex justify-center gap-4">
          <button className="rounded-xl bg-strawberry-600 px-4 py-2 font-semibold text-white" onClick={() => { startup = undefined; setStatus("loading"); setAttempt(v => v + 1); }}>Try again</button>
          <button className="rounded-xl border border-cloud-300 px-4 py-2" onClick={() => { setStatus("loading"); void signOutSession().finally(() => setStatus("ready")); }}>Sign out</button>
        </div>}
      </div>
    </main>
  );
}
